module.exports = __webpack_public_path__ + "assets/playkids-logo.9670b653.svg";